import { Component, AfterViewInit, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as L from 'leaflet';
import { Subscription } from 'rxjs';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { WebsocketService } from 'src/app/shared/service/websocket/websocket.service';
declare const windyInit: any;

@Component({
  selector: 'app-test-map',
  templateUrl: './test-map.component.html',
  styleUrls: ['./test-map.component.scss'],
})
export class TestMapComponent implements OnInit {
  moduleName: any;
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.moduleName = params['module'] || 'Technical Performance Module';
    });
  }
}
